var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[_c('div',{staticClass:"stk-key-info-label"},[(_vm.icon)?_c(_setup.Icon,{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"stk-key-info-label-text"},[_vm._t("label")],2)],1),_vm._v(" "),_c('div',{staticClass:"stk-key-info-main"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }